import { Config } from './types';

export const gamma: Config = {
  CONSENT_MANAGER_SCRIPT_URL:
    'https://db8rtia09p9iz.cloudfront.net/common/static/consent-manager.js',
  HEAP_ID: '2552228339',
  RWA_CLIENT_ID: 'RingtercomCompatibilityChecker',
  RWA_AWS_REGION: 'us-east-1',
  RWA_EVENT_STREAM_ENDPOINT: 'https://eventstream.qa.ring.com/anon',
  RWA_GROUP: 'client.device',
  RWA_SUBGROUP: 'ring.site.webapp',
};
